import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Score as Desc } from './desk'
import { Score as Mob } from './mob'

type Props = {
  images: TImages
}
export const Score: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
